import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#' },
  { label: '热门话题', href: '#topics' },
  { label: '专题索引', href: '#index' },
  { label: '投稿爆料', href: '#contact' },
  { label: '关于我们', href: '#about' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    if (href === '#') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-[1280px] mx-auto px-4 md:px-6 h-[72px] flex items-center justify-between">
        <a
          href="#"
          onClick={(e) => handleNavClick(e, '#')}
          className="flex items-center gap-2 no-underline cursor-pointer"
        >
          <span className="text-xl md:text-2xl font-heading font-black text-foreground-950 tracking-tight">
            黑料<span className="text-primary-500">视频</span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-md whitespace-nowrap cursor-pointer no-underline"
            >
              {item.label}
            </a>
          ))}
        </div>

        <div className="hidden md:block">
          <a
            href="#contact"
            onClick={(e) => handleNavClick(e, '#contact')}
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
          >
            最新传送门
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-900 cursor-pointer bg-transparent border-0"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, '#contact')}
              className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
            >
              最新传送门
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}